export default {
  PROGRAMME_PLAN_ERROR: 'Please choose your package',
  PAYMENT_PLAN_ERROR: 'Please choose your payment plan',
  DIGITAL_ONLY_ERROR:
    'Sorry - only the Digital package is available in your country at the moment!',
  PAYPAL_NOT_LOADED_ERROR: 'Error - PayPal not loaded. Please contact support',
  STRIPE_NOT_LOADED_ERROR:
    'Error loading payment processor (stripe). Please contact support.',
  PAYMENT_METHOD_MISSING:
    'Error processing your payment method. Please contact support.',
  PROMOCODE_API_ERROR: 'Error with API call - please contact support',
  PROMOCODE_NOT_VALID: "I'm sorry, this code isn't valid!",
  PROMOCODE_EXPIRED: "I'm sorry, but this code has expired!",
  PROMOCODE_ALREADY_USED: "I'm sorry, this code has already been used!",
  PAYPAL_POPUP_CLOSED:
    'The PayPal popup was closed before checkout was completed',
  PAYPAL_POPUP_OPEN_FAILED: 'Enable pop-ups in your browser & try again',
  ERROR_WITH_USER_CALL: 'Error with user API call - please contact support',
} as const;
